import type {
  RecruitingJobLocationOption,
  RecruitingJobProvince,
} from '@gokrew/models/recruiting';

/** The job form fields the location picker reads and fills. */
export interface JobLocationValues {
  city: string;
  province: RecruitingJobProvince | '';
  postalCode: string;
}

/** The picker's value for a one-off address typed by hand. */
export const OTHER_ADDRESS = 'other';

/** Text compared without spaces or case (city, postal code). */
export const compact = (value: string | null | undefined) =>
  (value ?? '').replace(/\s+/g, '').toLowerCase();

/** The company location whose city, province and postal code the form holds. */
export const matchLocation = (
  locations: RecruitingJobLocationOption[],
  values: JobLocationValues
) =>
  locations.find(
    (location) =>
      !!location.city &&
      compact(location.city) === compact(values.city) &&
      (location.province ?? '') === values.province &&
      compact(location.postalCode) === compact(values.postalCode)
  );

/** What picking a location writes into the form. */
export const locationValues = (
  location: RecruitingJobLocationOption
): JobLocationValues => ({
  city: location.city ?? '',
  province: location.province ?? '',
  postalCode: location.postalCode ?? '',
});
